import { FC } from 'react';
import { DateTimeUtils, useDateTimeLocalizationInfo, useTimezone } from '@mews/framework';
import { SpacedDash } from '@mews-commander/ui';
import { EnrichedReservation } from './types';

interface ReservationLabelProps {
    reservation: EnrichedReservation;
}

export const ReservationLabel: FC<ReservationLabelProps> = ({ reservation }) => {
    const timezone = useTimezone();
    const dateTimeLocalizationInfo = useDateTimeLocalizationInfo();

    const startDateString = DateTimeUtils.dateTimeUtcStringToDateString(
        reservation.startUtc,
        dateTimeLocalizationInfo,
        timezone
    );

    const endDateString = DateTimeUtils.dateTimeUtcStringToDateString(
        reservation.endUtc,
        dateTimeLocalizationInfo,
        timezone
    );

    return <>{`${startDateString}${SpacedDash}${endDateString}`}</>;
};
